module.exports = __webpack_public_path__ + "media/images/new_home/sponsor-logo-7-a7e3e209ca3c18b448dc5dbbad32d8b1.png";